/**
 * SchemaJsonLd — renders a JSON-LD script block for structured data.
 * Used in App.jsx to output all schema.org blocks.
 *
 * Props:
 *   data: object — the JSON-LD data to render
 */
export default function SchemaJsonLd({ data }) {
  if (!data) return null;
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}
